import React, { useState } from "react";
import { useTheme } from "../context/ThemeContext";
import "./CreateQuiz/CreateQuiz.css";
import { loginLearner } from '../api/api';

const LoginModal = ({ onLogin }) => {
    const { themeStyles } = useTheme();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await loginLearner({ email: email, password: password })
            onLogin(response);
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 ">
            <div
                className="p-6 w-96 rounded-lg shadow-md border"
                style={{
                    background: themeStyles.cardBackground,
                    color: themeStyles.text,
                }}
            >
                <div className="mb-4 text-center font-semibold mb-4">
                    Please log in to your account to attempt the quiz.
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group mb-4">
                        <label htmlFor="email" className="block mb-1">
                            Email ID
                        </label>
                        <input
                            type="text"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your login ID"
                            required
                            className="w-full p-2 rounded"
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                    <div className="form-group mb-4">
                        <label htmlFor="password" className="block mb-1">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                            className="w-full p-2 rounded"
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                    {error && <div className="text-center text-sm font-semibold mb-4 text-red-500">
                        {error}
                    </div>}
                    <button
                        type="submit"
                        className="w-full py-2 mt-4 rounded bg-custom-blue text-white hover:bg-blue-800"
                    >
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginModal;
